import * as autosize from "autosize";
import { getUITranslation } from "../utils/get_ui_translation";

let $editingElement = null;
let all_orientations = [];

$(function () {
  $(document)
    .on("click", ".js-trainee-form .dpc-orientation .orientation", onShowPicker)
    .on("click", ".js-trainee-form .dpc-orientation .profession", onShowPicker)
    .on("click", ".pick-dpc-form .orientation button", onPick)
    .on("click", ".pick-dpc-form .cancel", onHidePicker)
    .on("click", ".pick-dpc-form .select-year", onSelectYear);
});

function onShowPicker(e) {
  onHidePicker(e);
  $editingElement = $(this).closest("li");
  showPicker();
}

function onHidePicker(e) {
  e.preventDefault();
  e.stopPropagation();
  $(".pick-dpc-form").remove();
}

function onPick(e) {
  let $e = $(this);
  let orientation = $e.text();
  let profession = findProfession(orientation);
  onHidePicker(e);
  $editingElement.find(".profession").val(profession);
  $editingElement.find(".orientation").val(orientation);
  autosize.update($(".autoresize"));
}

function showPicker() {
  all_orientations = window.dpc_orientations_2023.concat(window.dpc_orientations_2020).concat(window.dpc_orientations_2018);

  let classicOrientations = makeClassicOrientations(window.dpc_classic_orientations);
  let allOrientations2018 = makeOrientations(window.dpc_orientations_2018);
  let allOrientations2020 = makeOrientations(window.dpc_orientations_2020);
  let allOrientations2023 = makeOrientations(window.dpc_orientations_2023);

  $("body").append(`
    <div class="pick-dpc-form">
      <div class="content">
        <div class="dpcs">
          <div class="scrollable">
            <div class="left">
              <p>Orientations courantes</p>
              <ul class="classic-orientations">
                ${classicOrientations}
              </ul>
            </div>
            <div class="right">
              <p>${getUITranslation("Toutes les orientations nationales")}</p>
              <div class="years">
                <button data-year="2023" class="select-year selected">2023</button>
                <button data-year="2020" class="select-year">2020</button>
                <button data-year="2018" class="select-year">${getUITranslation("Avant 2020")}</button>
              </div>
              <div class="orientations-year" data-year="2023" id="orientations-2023">
                ${allOrientations2023}
              </div>
              <div class="orientations-year" data-year="2020" id="orientations-2020" style="display: none">
                ${allOrientations2020}
              </div>
              <div class="orientations-year" data-year="2018" id="orientations-2018" style="display: none">
                ${allOrientations2018}
              </div>
            </div>
          </div>
        </div>

        <div class="buttons">
          <button class="button button--ghost cancel">${getUITranslation("Annuler")}</button>
        </div>

      </div>
    </div>
  `);
}
function onSelectYear() {
  const year = $(this).data("year");
  $(".orientations-year").hide();
  $("#orientations-" + year).show();
  $(".select-year").removeClass("selected");
  $(this).addClass("selected");
}

function findProfession(orientation) {
  let category = _.find(all_orientations, function (category) {
    return _.includes(category.orientations, orientation);
  });
  if (category) {
    return category.professions.join("\n");
  } else {
    return "";
  }
}

function makeOrientations(professionCategories) {
  let str = "";
  for (var professionCategory of professionCategories) {
    let orientations = "";
    for (var orientation of professionCategory.orientations) {
      orientations += `
        <li class="orientation">
          <button>${orientation}</button>
        </li>
      `;
    }

    let professions = "";
    for (var profession of professionCategory.professions) {
      professions += `
        <li class="profession">${profession}</li>
      `;
    }

    str += `
      <div class="profession-category">
        <ul class="professions">${professions}</ul>
        <ul class="orientations">${orientations}</ul>
      </div>
    `;
  }
  return str;
}

function makeClassicOrientations(classicOrientations) {
  let str = "";
  for (var classicOrientation of classicOrientations) {
    let profession = findProfession(classicOrientation);
    str += `
      <li class="classic-orientation">
        <div class="profession">${profession}</div>
        <div class="orientation">
          <button>${classicOrientation}</button>
        </div>
      </li>
    `;
  }
  return str;
}
